/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Pr_Type_VmaInputs */

const fr_leaderboard_pr_type_vma = /** @type {(inputs: Leaderboard_Pr_Type_VmaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VMA`)
};

/**

* @param {Leaderboard_Pr_Type_VmaInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_pr_type_vma = /** @type {((inputs?: Leaderboard_Pr_Type_VmaInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Pr_Type_VmaInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_pr_type_vma(inputs)
});